import React from 'react';
import { Helmet } from 'react-helmet-async';
import './TeamGrid.css';
import shannon from '../../assets/shannon.jpg';
import edith from '../../assets/edith.jpg';
import tim from '../../assets/tim.jpg';
import aslan from '../../assets/aslan.jpg';
import andrew from '../../assets/andrew.png';
import jecinta from '../../assets/jecinta.jpg';
import kamau from '../../assets/kamau.jpg';
import joylizza from '../../assets/joylizza.jpg';
import ida from '../../assets/ida.jpg';
import josephine from '../../assets/josephine.jpg';
import ken from '../../assets/ken.jpeg';
import ndai from '../../assets/ndai.jpeg';

const externalValues = [
  { title: "Open Access", desc: "Quantum knowledge and opportunities should not be gatekept." },
  { title: "Inclusivity", desc: "Talent is everywhere; opportunity should be too." },
  { title: "Tech Agnosticism", desc: "We embrace all tools, platforms, and approaches that advance learning and innovation." },
  { title: "Excellence", desc: "We aim for globally competitive standards in research, talent, and output." },
  { title: "Pan-African Mindset", desc: "We build for Kenya, but think for Africa and the world." },
  { title: "Innovation-Driven", desc: "We focus on frontier technologies with real-world impact." },
];

const internalValues = [
  { title: "Ownership", desc: "If you take it on, you drive it to completion." },
  { title: "Collaboration", desc: "We build together, not in silos." },
  { title: "Respect", desc: "We value diverse perspectives and communicate constructively." },
  { title: "Accountability", desc: "We follow through and hold each other to high standards." },
  { title: "Bias for Action", desc: "We prioritize execution over endless planning." },
  { title: "Continuous Learning", desc: "We actively grow, share, and improve as a team." },
];

const TeamGrid = () => {
  const teamMembers = [
    { name: 'Shannon Mujera',    role: 'Community & Team Lead',        imageUrl: shannon   },
    { name: 'Timothy Githaiga',  role: 'Development Programs Lead',     imageUrl: tim       },
    { name: 'Joylizza Mwangi',   role: 'Community Events Lead',         imageUrl: joylizza  },
    { name: 'Kelvin Kamau',      role: 'Legal & Compliance Lead',       imageUrl: kamau     },
    { name: 'Ida Nganga',        role: 'Strategic Partnerships Lead',   imageUrl: ida       },
    { name: 'Ndeto Ndugu',       role: 'Budget & Finance Lead',         imageUrl: aslan     },
    { name: 'Diana Wangui',      role: 'Design & Creative Lead',        imageUrl: edith     },
    { name: 'Kenneth Njoroge',   role: 'Technical Lead',        imageUrl: ken },
    { name: 'Jecinta Kazenzi',   role: 'Engagement Programs Lead',      imageUrl: jecinta   },
    { name: 'Andrew Njagi',      role: 'Academic Programs Lead',        imageUrl: andrew    },
    { name: 'Josephine Njeri',   role: 'Digital Marketing Lead',        imageUrl: josephine },
    { name: 'Michael Ndai',   role: 'Research Lead',        imageUrl: ndai }, 
    
  ];

  return (
    <>
      <Helmet>
        <title>Our Team | QuantumKE</title>
        <meta name="description" content="Meet the QuantumKE team — a dedicated group of researchers, developers, and advocates building Kenya's quantum technology ecosystem." />
        <link rel="canonical" href="https://quantumke.org/team" />
      </Helmet>

      {/* Banner */}
      <div className="team-banner">
        <div className="team-banner-glow" aria-hidden="true" />
        <div className="team-banner-inner">
          <div className="team-banner-text">
            <h1 className="team-banner-title">Our Community Builders</h1>
            <p className="team-banner-sub">
              Meet the dedicated team behind QuantumKE — researchers, innovators, and advocates building Kenya's quantum technology ecosystem.
            </p>
          </div>
        </div>
      </div>

      {/* Our Identity & Culture */}
      <section className="values-section">
        <div className="values-container">

          <div className="values-block">
            <div className="values-block-header">
              <span className="values-tag">What We Represent</span>
              <h2 className="values-block-title">Our Identity</h2>
              <p className="values-block-subtitle">The principles that guide how the world sees QuantumKE</p>
            </div>
            <div className="ext-values-list">
              {externalValues.map((v, i) => (
                <div className="ext-value-row" key={i}>
                  <span className="ext-value-num">{String(i + 1).padStart(2, '0')}</span>
                  <h3 className="ext-value-title">{v.title}</h3>
                  <p className="ext-value-desc">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="values-section-divider" />

          {/* Our Culture */}
          <div className="values-block">
            <div className="values-block-header">
              <span className="values-tag culture-tag">How We Work</span>
              <h2 className="values-block-title">Our Culture</h2>
              <p className="values-block-subtitle">The behaviors that define how we operate every day</p>
            </div>
            <div className="culture-bento">
              {internalValues.map((v, i) => (
                <div className="culture-item" key={i}>
                  <span className="culture-item-num">{String(i + 1).padStart(2, '0')}</span>
                  <h3>{v.title}</h3>
                  <p>{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* Team Grid */}
      <div className="team-container">
        <div className="team-section-header">
          <span className="team-section-eyebrow">The People</span>
          <h2 className="team-section-title">Meet the Builders</h2>
          <p className="team-section-sub">The individuals driving QuantumKE's mission forward</p>
        </div>
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.name} className="team-member">
              <div className="member-image-container">
                <img
                  src={member.imageUrl}
                  alt={member.name}
                  className="member-image"
                />
              </div>
              <h3 className="member-name">{member.name}</h3>
              <p className="member-role">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TeamGrid;
